export const CREATE_PROJECT_CREATOR_DOCUMENT_MUTATION = `
    mutation CreateProjectCreatorDocument($project_id: Int!, $project_creator_id: Int!, $upload_path: String, $tag: String, $invoice_amount: String, $filename: String, $label: String!, $thumbnail: String, $type: ProjectCreatorDocumentTypeEnum, $custom_properties: [CustomPropertyInput]) {
        createProjectCreatorDocument(project_id: $project_id, project_creator_id: $project_creator_id, upload_path: $upload_path, tag: $tag, invoice_amount: $invoice_amount, filename: $filename, label: $label, thumbnail: $thumbnail, type: $type, custom_properties: $custom_properties) {
            id
            project_id
            project_creator_id
            uploaded_by
            tag
            filename
            label
            thumbnail
            type
            created_at
            updated_at
            project_creator {
                id
                deliverable_count
                notes
                client_notes
                initial_quote
                favorite
                confirmed
                example_content
                avatar
                decision
                tiktok_reach
                tiktok_impressions
                tiktok_engagement_rate
                instagram_reach
                instagram_impressions
                instagram_engagement_rate
                youtube_reach
                youtube_impressions
                youtube_engagement_rate
            }
            custom_properties {
                key
                value
            }
        }
    }
`;

export const UPDATE_PROJECT_CREATOR_DOCUMENT_MUTATION = `
    mutation UpdateProjectCreatorDocument($id: Int!, $upload_path: String, $tag: String, $filename: String, $label: String, $thumbnail: String, $type: ProjectCreatorDocumentTypeEnum, $custom_properties: [CustomPropertyInput]) {
        updateProjectCreatorDocument(id: $id, upload_path: $upload_path, tag: $tag, filename: $filename, label: $label, thumbnail: $thumbnail, type: $type, custom_properties: $custom_properties) {
            id
            project_id
            project_creator_id
            uploaded_by
            tag
            filename
            label
            thumbnail
            type
            created_at
            updated_at
            project_creator {
                id
                deliverable_count
                notes
                client_notes
                initial_quote
                favorite
                confirmed
                example_content
                avatar
                decision
                tiktok_reach
                tiktok_impressions
                tiktok_engagement_rate
                instagram_reach
                instagram_impressions
                instagram_engagement_rate
                youtube_reach
                youtube_impressions
                youtube_engagement_rate
                contract {
                    id
                    status
                    contract_value
                    kill_fee
                    content_ownership_id
                    content_rights
                    content_rights_expiration_date
                    ecom_asset_ownership
                    ecom_asset_expiration_date
                    indeminity
                    whitelisting
                    whitelisting_expiration
                    term_date
                    notes
                }
            }
            custom_properties {
                key
                value
            }
        }
    }
`;

export const DELETE_PROJECT_CREATOR_DOCUMENT_MUTATION = `
    mutation DeleteProjectCreatorDocument($id: Int!, $project_id: Int!) {
        deleteProjectCreatorDocument(id: $id, project_id: $project_id)
    }
`;
